import { SHOW_SIDE_VIEW, HIDE_SIDE_VIEW, SHOW_THUMB_VIEW, HIDE_THUMB_VIEW,
         ZOOM_IN, ZOOM_OUT, SHOW_ZOOM_AREA, HIDE_ZOOM_AREA, WINDOW_SIZE,
         CALC_DOCUMENT_RATIO, USER_AGENT, SHOW_NOTIFICATION,
         REQUEST_POSTS, RECEIVE_POSTS, MOVE_PAGE, CHECK_PASSWORD,
         SHOW_INPUT_META, HIDE_INPUT_META
       } from './actions'
import { combineReducers } from 'redux'
import { loadingBarReducer } from 'react-redux-loading-bar'

const defaultState = {
    showSideView: false,
    showThumbView: false,
    showZoomArea: true,
    showPrintArea: true,
    showRatio: 1.0,
    screenInfo: {},
    docRatio: 1.0,
    userAgent: {},
    notiData: {},
    showInputMeta :{ isShow : false},
}

const extra = (state = defaultState, action) => {
    switch(action.type) {
    case SHOW_SIDE_VIEW:
        return Object.assign({}, state, {
            showSideView: true,
        })
    case HIDE_SIDE_VIEW:
        return Object.assign({}, state, {
            showSideView: false,
        })
    case SHOW_THUMB_VIEW:
        return Object.assign({}, state, {
            showThumbView: true,
        })
    case HIDE_THUMB_VIEW:
        return Object.assign({}, state, {
            showThumbView: false,
        })
    case ZOOM_IN: {
        return Object.assign({}, state, {
            showRatio: state.showRatio + action.increment,
        })
    }
    case ZOOM_OUT: {
        return Object.assign({}, state, {
            showRatio: state.showRatio - action.increment,
        })
    }
    case SHOW_ZOOM_AREA: 
        return Object.assign({}, state, {
            showZoomArea: true,
        })
    case HIDE_ZOOM_AREA: 
        return Object.assign({}, state, {
            showZoomArea: false,
        })
    case WINDOW_SIZE:
        return Object.assign({}, state, {
            screenInfo: action.size,
        })
    case CALC_DOCUMENT_RATIO:
        const { screenInfo } = state
        const { size } = action

        // if (screenInfo.width == 0) {
        //     screenInfo.width = 868;
        // }
        let needResize = (screenInfo.width - 30) < size.w
        console.log("CALC_DOCUMENT_RATIO screenInfo.width : " + screenInfo.width);
        console.log("CALC_DOCUMENT_RATIO size.width : " + size.w);
        console.log("CALC_DOCUMENT_RATIO needResize : " + needResize);
        let docRatio = (screenInfo.width > 0 ? (needResize ? (screenInfo.width - 30) / size.w : 1.0): 1.0);
        return Object.assign({}, state, {
            docRatio: docRatio,
        })
    case USER_AGENT:
        return Object.assign({}, state, {
            userAgent: action.ua,
        })
    case SHOW_NOTIFICATION:
        return Object.assign({}, state, {
            notiData: action.noti,
        })
    case SHOW_INPUT_META:
        return Object.assign({}, state, {
            showInputMeta: {
                isShow : true
            },
            metaIndex : action.metaIndex,
            metaType : action.metaType,
        })
    case HIDE_INPUT_META:
         return Object.assign({}, state, {
            showInputMeta: {
                isShow : false
            }
        })

    default:
        return state;
    }
}


function posts(state = {
    isFetching: false,
    items: {}
}, action) {
    switch (action.type) {
    case REQUEST_POSTS:
        return Object.assign({}, state, {
            isFetching: true,
        })
    case RECEIVE_POSTS:
        return Object.assign({}, state, {
            isFetching: false,
            items: action.posts,
            lastUpdated: action.receiveAt,
        })
    default:
        return state
    }
}

const defaultStatus = {
    index: 0,
    moveIndex: 0,
    openStatus: {},
    showProgress: false,
    checkPassword: false,
}

function postsByCommand(state = defaultStatus, action) {
    const { command, type } = action
    switch (type) {
    case RECEIVE_POSTS:
        if (action.status !== 200 || action.posts.cd !== '0000') {
            return Object.assign({}, state, {
                [command] : posts(state[command], action),
            })
        } else {
            switch(command) {
            case 'open':
                return Object.assign({}, state, {
                    openStatus: {
                        fileInfo: {
                            handle: action.posts.data.handle,
                            lockPassword: action.posts.data.hasPassword,
                            hasTSA: action.posts.data.hasTSA,
                            TSATime: action.posts.data.TSATime,
                            isTSA: action.posts.data.isTSA,
                        }
                    },
                    [command]: posts(state[command], action),
                })
            case 'pageInfo':
                return Object.assign({}, state, {
                    openStatus: Object.assign({}, state.openStatus, {
                        pageInfo: action.posts,
                    }),
                    [command]: posts(state[command], action),
                })
            case 'pageImage':
                return Object.assign({}, state, {
                    index: state.moveIndex === action.posts.data.pageIndex ? state.moveIndex : state.index,
                    openStatus: Object.assign({}, state.openStatus, {
                        current: action.posts,
                    }),
                    [command]: posts(state[command], action),
                })
            case 'metaInfo':
                return Object.assign({}, state, {
                    openStatus: Object.assign({}, state.openStatus, {
                        metaInfo: action.posts,
                    }),
                    [command]: posts(state[command], action),
                })
            case 'thumbnail':
                return Object.assign({}, state, {
                    openStatus: Object.assign({}, state.openStatus, {
                        thumbnail: action.posts,
                    }),
                    [command]: posts(state[command], action),
                })
            case 'inputPassword':
                return Object.assign({}, state, {
                    openStatus: Object.assign({}, state.openStatus, {
                        fileInfo: Object.assign({}, state.openStatus.fileInfo, {
                            lockPassword: action.posts.data.isLock,
                        })
                    }),
                    [command]: posts(state[command], action),
                    showProgress: false,
                })
            default:
                return Object.assign({}, state, {
                    [command] : posts(state[command], action),
                })
            }
        }
    case REQUEST_POSTS:
        function isShowProgress() {
            switch(command) {
            case 'inputPassword':
                return true
            default:
                return false
            }
        }
        return Object.assign({}, state, {
            [command] : posts(state[command], action),
            showProgress: isShowProgress(),
        })
    case MOVE_PAGE:
        return Object.assign({}, state, {
            moveIndex: action.index,
        })
    case CHECK_PASSWORD:
        return Object.assign({}, state, {
            checkPassword: true,
        })
    default:
        return state
    }
}

const Reducers = combineReducers({
    extra,
    viewer: postsByCommand,
    loadingBar: loadingBarReducer,
})

export default Reducers



// WEBPACK FOOTER //
// ./src/reducers.js